




import { defineComponent, ref, watch, nextTick, toRefs } from '@vue/composition-api';

const name = 'ttam-video-player';
const xgplayerLangMap = { en: 'en', ja: 'jp', zh: 'zh-cn' };

export default defineComponent({
  name,
  props: {
    src: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: 'en',
    },
    poster: {
      type: String,
      default: '',
    },
    volume: {
      type: Number,
      default: 0.6,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    showControl: {
      type: Boolean,
      default: false,
    },
    ignores: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const { src } = toRefs(props);
    const refPlayer = ref(null);
    const isInited = ref(false);
    const player = ref(null);

    const playReady = () => {
      nextTick(() => {
        player.value.on('volumechange', function onChange() {
          ctx.emit('volumechange', props.volume);
        });
      });
    };

    const emitClick = () => {
      ctx.emit('click');
    };

    async function initPlayer() {
      if (!refPlayer.value) {
        return;
      }
      isInited.value = false;
      player.value = null;
      const { default: Player } = await import(/* webpackChunkName: "xgplayer" */ 'xgplayer');
      player.value = new Player({
        enableContextmenu: true,
        ignores: props.ignores as any,
        el: refPlayer.value,
        url: props.src,
        volume: props.volume,
        poster: props.poster,
        autoplay: props.autoplay,
        lang: xgplayerLangMap[props.lang] || xgplayerLangMap.en,
        controls: props.showControl,
        width: '100%',
        height: '100%',
      });
      player.value.on('play', () => {
        ctx.emit('video-play');
        emitClick();
      });
      player.value.on('pause', () => {
        emitClick();
      });
      player.value.on('ended', () => {
        ctx.emit('video-ended');
      });
      player.value.on('timeupdate', () => {
        ctx.emit('video-timeupdate', player.value.currentTime);
      });
      // 实例暴露出去
      player.value.once('ready', () => {
        ctx.emit('ready', player.value);
      });
      playReady();
      isInited.value = true;
    }

    watch(
      [src],
      () => {
        if (src.value) {
          nextTick(() => {
            initPlayer();
          });
        }
      },
      { immediate: true },
    );

    return { name, refPlayer, emitClick, player };
  },
});
